import React, {Component} from 'react';
import LocalizedStrings from '../localization/strings';

const availableMenuItems = [
    {
        title_key: 'hello',
        url: '/'
    }, {
        title_key: 'news',
        url: '/posts'
    }, {
        title_key: 'regulations',
        url: '/regulations'
    }, {
        title_key: 'stages',
        url: '/stages'
    }, {
        title_key: 'results',
        url: '/results'
    }, {
        title_key: 'archive',
        url: '/archive'
    }, {
        title_key: 'contacts',
        url: '/contact'
    }, {
        title_key: 'about',
        url: '/about'
    },
    {
        title_key: 'participantResults',
        url: '/participant-results'
    }
]
export default class MenuBuilder extends Component {
    getCurrentMenuValue() {
        return this.props.value || [];
    }
    addDefaultMenuItem(item) {
        this.addItemToMenu({
            title_en: LocalizedStrings.props.en[item.title_key],
            title_lt: LocalizedStrings.props.lt[item.title_key],
            url: item.url
        });
    }
    addItemToMenu(item) {
        let value = this.getCurrentMenuValue();
        value.push(item);
        this.props.onChange(value);
    }
    removeItemFromMenu(index) {
        let value = this.getCurrentMenuValue();
        value.splice(index, 1);
        this.props.onChange(value);
    }

    addNewItemToMenu() {
        if (this.titleEnInput.value && this.titleLtInput.value && this.urlInput.value) {
            this.addItemToMenu({title_en: this.titleEnInput.value, title_lt: this.titleLtInput.value, url: this.urlInput.value});

            this.titleEnInput.value = '';
            this.titleLtInput.value = '';
            this.urlInput.value = '';
        }

    }
    render() {
        const currentMenuItems = this.getCurrentMenuValue();
        return (
            <div className="menu-builder">

                <div className="col">
                    <div className="title">{LocalizedStrings.availableMenuItems}</div>
                    {availableMenuItems.map((item) => {
                        return (
                            <div className="menu-item">
                                <div className="description">
                                    {LocalizedStrings[item.title_key]}
                                    <div className="link">{item.url}</div>
                                </div>
                                <a className="btn" onClick={() => this.addDefaultMenuItem(item)}>
                                    {LocalizedStrings.add}
                                </a>
                            </div>
                        )
                    })}
                    <div className="menu-item-form">
                        <input ref={(ref) => this.titleEnInput = ref} placeholder={LocalizedStrings.title_en}/>
                        <input ref={(ref) => this.titleLtInput = ref} placeholder={LocalizedStrings.title_lt}/>
                        <input ref={(ref) => this.urlInput = ref} placeholder={LocalizedStrings.url}/>
                        <a className="btn" onClick={() => this.addNewItemToMenu()}>
                            {LocalizedStrings.addToMenu}
                        </a>
                    </div>
                </div>
                <div className="col">
                    <div className="title">{LocalizedStrings.currentMenuItems}</div>
                    {currentMenuItems.map((item, index) => {
                        return (
                            <div className="menu-item">
                                <div className="description">
                                    {item.title_lt}({item.title_en})
                                    <div className="link">{item.url}</div>
                                </div>
                                <a className="btn" onClick={() => this.removeItemFromMenu(index)}>
                                    x
                                </a>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./src/js/components/menu-builder.js